<template>
  <PublicPopup
    ref="PopupRef"
    type="fullScreen"
    :height="95"
    position="bottom"
    @close="emit('close')"
  >
    <template #content>
      <div class="download-guide-popup">
        <div class="header-container">
          <van-icon name="arrow-left" class="arrow-icon" @click="handlePopupClose" />
          <p class="title">{{ $t('DownloadPopup-DownloadGuidePopup2.title') }}</p>
        </div>

        <div class="main-content">
          <img
            :src="getImageUrlWithCDN_TEST('/download/img_jc_ios_describe_en.png', 'local')"
            class="images"
          />
        </div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const PopupRef = ref(null)
const open = () => {
  nextTick(() => {
    PopupRef.value.open()
  })
}
const handlePopupClose = () => {
  PopupRef.value.close()
}

const emit = defineEmits(['close'])

defineExpose({
  open,
})
</script>

<style lang="scss" scoped>
$header-height: 42px;
.download-guide-popup {
  width: 100%;
  height: 100%;
  background-color: var(--download-guide-popup-bg);
  border-radius: 10px 10px 0 0;

  .header-container {
    position: relative;
    width: 100%;
    height: $header-height;
    border-bottom: 1px solid var(--download-guide-popup-header-border);
    font-size: 16px;
    text-align: center;
    line-height: $header-height;

    .title {
      color: var(--popup-primary-title);
    }
    .arrow-icon {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 16px;
      color: var(--download-guide-popup-close-icon);
    }
  }

  .main-content {
    padding: 10px;
    height: calc(100% - $header-height);
    overflow-y: auto;
  }

  .content-card-title {
    margin-top: 12px;

    .title {
      font-size: 14px;
      color: var(--download-guide-popup-content-label);
    }

    .content {
      font-size: 12px;
      color: var(--download-guide-popup-content-text);

      .web-name {
        color: var(--download-guide-popup-content-web);
      }
    }
  }

  .content-card-images {
    margin-top: 12px;

    .images {
      width: 90%;
    }
  }
}
</style>
